import React from 'react';
import { ArrowRight, Phone, Star } from 'lucide-react';
import { heroImage, chaiImage } from '../mock';

const Hero = () => {
  return (
    <section id="top" className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#f4ead4] via-[#ecdcbf] to-[#e5cfa8]" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-10 pt-10 pb-24 lg:pt-16 lg:pb-32">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left */}
          <div>
            <div className="inline-flex items-center gap-2 bg-[#2a1a0f]/10 rounded-full px-4 py-2 mb-8">
              <span className="w-1.5 h-1.5 rounded-full bg-[#b8532a]" />
              <span className="text-[12px] tracking-[0.12em] font-medium text-[#2a1a0f] uppercase">
                Quesnel, BC · Neighbourhood Café
              </span>
            </div>

            <h1 className="font-serif text-[52px] sm:text-[64px] lg:text-[76px] leading-[1.02] text-[#2a1a0f] tracking-tight">
              The first sip of a slow morning, poured right here.
            </h1>

            <p className="mt-8 text-[17px] leading-relaxed text-[#4a3524] max-w-xl">
              Small-batch coffee, warm baking, and a corner that always feels like yours. Ten
              minutes of your time, all the comfort you need.
            </p>

            <div className="mt-8 flex items-center gap-6 flex-wrap">
              <div className="flex items-center gap-3">
                <div className="flex">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} className="w-4 h-4 fill-[#c88a3a] text-[#c88a3a]" />
                  ))}
                </div>
                <span className="text-[15px] text-[#2a1a0f]">
                  <span className="font-medium">4.7</span>
                  <span className="text-[#7a5c40]"> · 183 Google reviews</span>
                </span>
              </div>
              <div className="h-4 w-px bg-[#2a1a0f]/20 hidden sm:block" />
              <span className="text-[15px] text-[#2a1a0f]">$10–20 per person</span>
            </div>

            <div className="mt-10 flex items-center gap-3 flex-wrap">
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=462+B+Anderson+Dr,+Quesnel,+BC+V2J+1G2"
                target="_blank"
                rel="noreferrer"
                className="group inline-flex items-center gap-3 bg-[#b8532a] hover:bg-[#a34620] text-[#f4ead4] px-6 py-3.5 rounded-full transition-colors"
              >
                <span className="text-[15px] font-medium">Find your way in</span>
                <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2} />
              </a>
              <a
  href="/preorder"
  className="group inline-flex items-center gap-3 bg-[#b8532a] hover:bg-[#a34620] text-[#f4ead4] px-6 py-3.5 rounded-full transition-colors"
>
  <span className="text-[15px] font-medium">Pre-Order Now</span>
  <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" strokeWidth={2} />
</a>
              <a
                href="tel:+12509927066"
                className="inline-flex items-center gap-3 bg-[#f4ead4]/60 hover:bg-[#f4ead4] border border-[#2a1a0f]/10 text-[#2a1a0f] px-6 py-3.5 rounded-full transition-colors"
              >
                <span className="w-6 h-6 rounded-full bg-[#2a1a0f] flex items-center justify-center">
                  <Phone className="w-3 h-3 text-[#f4ead4]" strokeWidth={2} />
                </span>
                <span className="text-[15px] font-medium">(250) 992-7066</span>
              </a>
            </div>
          </div>

          {/* Right - image with floating cards */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-xl aspect-[5/4]">
              <img
                src={heroImage}
                alt="Latte art in a cozy café"
                className="w-full h-full object-cover"
              />
              <div className="absolute top-5 right-5 bg-[#2a1a0f]/85 backdrop-blur-sm text-[#f4ead4] text-[13px] px-4 py-2 rounded-full">
                Tue–Sat · 10:30–6:30
              </div>
            </div>

            <div className="absolute -bottom-8 right-4 lg:right-8 bg-[#f4ead4] shadow-lg rounded-2xl p-3 pr-6 flex items-center gap-3">
              <img
                src={chaiImage}
                alt="Authentic Chai"
                className="w-14 h-14 rounded-xl object-cover"
              />
              <div>
                <div className="font-serif text-[17px] text-[#2a1a0f] leading-tight">Authentic Chai</div>
                <div className="text-[13px] text-[#7a5c40] mt-0.5">House favourite · $3.80</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
